import React from 'react';
import { LinkComponent } from '../LinkComponent';
import { Title } from './page-components/Title';

interface IRightSideContainerProps {
	title: string;
	text: string;
	linkText?: string;
	link?: string;
	isUnderLine?: boolean;
}

export const RightSideContainer = ({ title, text, linkText='Learn more', link, isUnderLine }: IRightSideContainerProps): JSX.Element => {
	return (
		<>
			<Title title={title} additionalClass="fs-2"/>
			<div className="mt-5 fs-6">{text}</div>
			{
				link && (
					<LinkComponent
						text={linkText}
						link={link}
						additionalClass="fs-6 d-block mt-5"
						isUnderLine={isUnderLine}
					/>
				)
			}
		</>
	);
};
